

import styles from './Safety.module.scss';
import Image from 'next/image';
const Safety = ({highlights}) => {
    return(
         <section className={`${styles.top_sec} common_padding`} id="helicopter_sec">
                <div className='container'>
                    <div className='row'>
                        {highlights.map((item, index) => (
                            <div className={`${styles.highlight_child} col-md-4 common_title animate_box`} key={index}>
                                <span><Image src={item.icon} width={44} height={44} alt={item.title}></Image></span>
                                <h3>{item.title}</h3>
                                <p>{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
    );
}
export default Safety;